import { isMobileDevice } from '../../lib/device';
import { BindCardOptions, CreateBindingParams } from '../../types';
import { getDomainSfx, langByDomainSfx, verifyLang } from '../../utils/common';

// eslint-disable-next-line complexity,max-statements
export const getCreateBindingParams = (options: BindCardOptions): CreateBindingParams => {
    const params: CreateBindingParams = {
        mode: 'default',
        modeSuccess: 'default',
        lang: langByDomainSfx(getDomainSfx()),
        isMobile: isMobileDevice(),
    };

    if (options.lang) {
        params.lang = verifyLang(options.lang);
    }

    if (options.mode) {
        params.mode = options.mode;
    }

    if (options.theme) {
        params.theme = options.theme;
    }

    if (options.modeSuccess) {
        params.modeSuccess = options.modeSuccess;
    }

    if (options.serviceToken) {
        params.serviceToken = options.serviceToken;
    }

    if (options.template) {
        params.template = options.template;
    }

    if (options.diehardTemplateTag) {
        params.diehardTemplateTag = options.diehardTemplateTag;
    }

    if (typeof options.remoteControl === 'boolean') {
        params.remoteControl = options.remoteControl;
    }

    if (typeof options.isMobile === 'boolean') {
        params.isMobile = options.isMobile;
    }

    if (options.currency) {
        params.currency = options.currency;
    }

    return params;
};
